// TKA 2-oct-2026: la aceptación dura solo la visita (sessionStorage), se guarda al instante
// y el error aparece solo al intentar pagar sin marcar la casilla.
if (!window.Eurus.loadedScript.has('cart-term.js')) {
  window.Eurus.loadedScript.add('cart-term.js');

  const TERM_KEY = 'cart_term_checked';
  const readTerm = () => {
    try { return sessionStorage.getItem(TERM_KEY) == 'agreed'; } catch (e) { return false; }
  };
  const writeTerm = (checked) => {
    try { sessionStorage.setItem(TERM_KEY, checked ? 'agreed' : 'not agreed'); } catch (e) {}
  };
  // La versión anterior recordaba la aceptación entre visitas
  try { localStorage.removeItem(TERM_KEY); } catch (e) {}

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartTerm', (message) => ({
        message: message,
        checked: false,
        error: false,
        shake: false,
        init() {
          this.checked = readTerm();

          this.$watch('checked', (value) => {
            writeTerm(value);
            if (value) this.error = false;
            this.save();
          });

          this.onValidate = (e) => {
            if (readTerm()) {
              // Si alguien marca y paga al instante, el atributo del carro se envía ya
              if (e.detail && e.detail.isCheckOut && this.pending) this.flush();
              return;
            }
            Alpine.store('xCartHelper').validated = false;
            if (e.detail && e.detail.isCheckOut && this.$el.isConnected) this.showError();
          };
          document.addEventListener('eurus:cart:validate', this.onValidate);
        },
        destroy() {
          document.removeEventListener('eurus:cart:validate', this.onValidate);
        },
        showError() {
          this.error = true;
          this.shake = false;
          requestAnimationFrame(() => { this.shake = true; });
          clearTimeout(this.shakeTimer);
          this.shakeTimer = setTimeout(() => { this.shake = false; }, 450);
          try { if (navigator.vibrate) navigator.vibrate(60); } catch (e) {}
          this.$el.scrollIntoView({ block: 'center', behavior: 'smooth' });
        },
        flush() {
          clearTimeout(this.t);
          this.pending = false;
          Alpine.store('xCartHelper').updateCart({
            attributes: {
              'Terms and conditions': this.checked ? 'agreed' : 'not agreed'
            }
          });
        },
        save() {
          clearTimeout(this.t);
          this.pending = true;
          this.t = setTimeout(() => { this.flush(); }, 200);
        }
      }));
    })
  });
};
